export const DepartmentNeslConfigsTabsIds = {
  NESL_PROFILES: 'nesl-profiles',
  EVENT_REVIEWERS: 'event-reviewers',
};
